module.exports = __webpack_public_path__ + "static/media/trait-icons-cooperativeness.4567fba1.svg";